import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as Actions from 'redux/actions/index';
import { renderCheck } from 'routes/Portfolio/Component/ActivityTab/TopicsTab/helper';

import './UserExtensionActionsHistory.scss';

function UserExtensionActionsHistory({ userId, actions }) {
  const [actionsHistory, setActionsHistory] = useState(null);
  const [loading, setLoading] = useState(false);

  async function getData() {
    try {
      console.log('get data');

      setLoading(true);

      const result = await actions.getUserExtensionActionsHistory(userId);

      setActionsHistory(result.actionsHistory);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    getData();
  }, []);

  if (loading) {
    return (
      <div
        className="fa fa-spin fa-spinner text-primary spinner"
        style={{ fontSize: '20px' }}
      />
    );
  }

  if (!actionsHistory) {
    return null;
  }

  const showTable = (action) => {
    return (
      <table>
        <thead>
          <tr>
            <th>Date</th>
            <th className="text-center">Installed</th>
            <th className="text-center">Logged In</th>
            <th className="text-center">Pinned</th>
            <th className="text-center">Device</th>
            <th className="text-center">Browser</th>
            <th className="text-center">Version</th>
          </tr>
        </thead>

        <tbody>
          {actionsHistory[action].map((item, index) => (
            <tr>
              <td>{moment(item.time).format('MM/DD/YYYY HH:mm')}</td>

              <td className="text-center">{renderCheck(item?.isInstalled)}</td>
              <td className="text-center">{renderCheck(item?.isLoggedIn)}</td>
              <td className="text-center">{renderCheck(item?.isPinned)}</td>

              <td className="text-center">{item?.device || '-'}</td>
              <td className="text-center">{item?.browser || '-'}</td>
              <td className="text-center">{item?.version || '-'}</td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  };

  return (
    <div className="user-extension-actions-history">
      <div className="user-extension-actions-history-table">
        <div className="table-title font-weight-600 mt-4 mb-2">Login</div>
        {showTable('isLoggedIn')}
      </div>
      <div className="user-extension-actions-history-table">
        <div className="table-title font-weight-600 mt-4 mb-2">Pin</div>
        {showTable('isPinned')}
      </div>
      <div className="user-extension-actions-history-table">
        <div className="table-title font-weight-600 mt-4 mb-2">Install</div>
        {showTable('isInstalled')}
      </div>
    </div>
  );
}

function mapStateToProps(state, ownProps) {
  return {};
}

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(Actions, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(UserExtensionActionsHistory);
